import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNewCamera = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M16.002 13c0 2.2091-1.7909 4-4 4-2.2092 0-4-1.7909-4-4 0-2.2091 1.7908-4 4-4 2.2091 0 4 1.7909 4 4zm-2 0c0 1.1046-.8955 2-2 2-1.1046 0-2-.8954-2-2s.8954-2 2-2c1.1045 0 2 .8954 2 2z",
		fill: "#111"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M9.4429 4 7.5858 7H3v13h18V7h-4.5859L14.557 4H9.4429zm1.1141 2h2.8859L15.3 9H19v9H5V9h3.6999l1.8571-3z",
		fill: "#111"
	})]
});
export default SvgNewCamera;
